/*** IMPORTS FROM imports-loader ***/
(function() {


/**
 * Created by costberg on 3/3/16.
 */

define('galileo/util/switchLocale',[],function() {
    return function(locale, callback) {
        if (window.global_page_viewer && window.global_page_viewer.encodedId) {
            require(['galileo/util/loggedInSwitchLocale'], function(loggedInSwitchLocale) {
                loggedInSwitchLocale(locale, window.global_page_viewer, callback);
            });
        } else {
            $.post('/i18n/switch', {
                    locale: locale,
                    csrfToken: window.fitbitCsrfToken
                },
                callback);
        }
    }
});}.call(window));


/** WEBPACK FOOTER **
 ** /home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/~/imports-loader?this=>window!/home/app/jenkins/workspace/deploy/aurora/build-docker-image-and-publish-artifacts/catpack/web_loaders/requirejs-loader?{"config":{"entryPaths":["./scripts/galileo/util/switchLocale.js"],"name":"galileo/util/switchLocale","paths":{"shared/build/css/components/shared/styles","com/conf/webapp/common/resources/i18n/com/fitbit","core/core/i18n/src/main/resources/resources/i18n/com/fitbit"},"inlineText":true,"pragmasOnSave":{"excludeHbs":true,"excludeI18n":true}}}!./scripts/galileo/util/switchLocale.js
 **/